import { i as isDev } from "./env-da4fbb25.mjs";
const warn = (...attrs) => {
  if (isDev) {
    console.warn(...attrs);
  }
  return false;
};
const throwError = (message) => {
  throw new Error(`[Vuestic] ${message}`);
};
export {
  throwError as t,
  warn as w
};
//# sourceMappingURL=console-33a7ea8d.mjs.map
